import React from "react";
import "./timelineCard.style.scss";
import CurrentChallenge from "../currentChallenge/currentChallenge.comp";

const TimelineCard = ({ imageURL, title, dateDone, onDisplayChallengeInfo, challengeObject }) => {

    return (
        <div
            style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}
        // onClick={() => onDisplayChallengeInfo(challengeObject.uniqueId_acceptedChallenge)}
        >
            <div
                style={{ display: 'flex', alignItems: 'center' }}
            >
                <p>{dateDone}</p>
            </div>
            <div
                onClick={onDisplayChallengeInfo}
                style={{
                    aspectRatio: '1 / 1',
                    height: '80px',
                    backgroundImage: `url(${imageURL})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    borderRadius: '20px',
                    cursor: 'pointer'
                }}
            >
                <div className="overlay"></div>
            </div>
            <div
                style={{ display: 'flex', alignItems: 'center' }}
            >
                <p
                    onClick={onDisplayChallengeInfo}
                    style={{ cursor: "pointer", fontWeight: '500' }}
                >{title}</p>
            </div>
        </div>
    );
};

export default TimelineCard;